const country = {
    AF: "아프가니스탄",
    AL: "알바니아",
    DZ: "알제리",
    AS: "아메리칸 사모아",
    AD: "안도라",
    AO: "앙골라",
    AG: "앤티가 바부다",
    AR: "아르헨티나",
    AM: "아르메니아",
    AU: "호주",
    AT: "오스트리아",
    AZ: "아제르바이잔",
    BS: "바하마",
    BH: "바레인",
    BD: "방글라데시",
    BB: "바베이도스",
    BY: "벨라루스",
    BE: "벨기에",
    BZ: "벨리즈",
    BJ: "베냉",
    BT: "부탄",
    BO: "볼리비아",
    BA: "보스니아 헤르체고비나",
    BW: "보츠와나",
    BR: "브라질",
    BN: "브루나이",
    BG: "불가리아",
    BF: "부르키나파소",
    BI: "부룬디",
    KH: "캄보디아",
    CM: "카메룬",
    CA: "캐나다",
    CV: "카보베르데",
    CF: "중앙 아프리카 공화국",
    TD: "차드",
    CL: "칠레",
    CN: "중국",
    CO: "콜롬비아",
    KM: "코모로스",
    CG: "콩고(브라자빌)",
    CD: "콩고(DRC)",
    CR: "코스타리카",
    CI: "코트디부아르",
    HR: "크로아티아",
    CU: "쿠바",
    CY: "키프로스",
    CZ: "체코 공화국",
    DK: "덴마크",
    DJ: "지부티",
    DM: "도미닉",
    DO: "도미니카 공화국",
    EC: "에콰도르",
    EG: "이집트",
    SV: "엘살바도르",
    GQ: "적도 기니",
    ER: "에리트레아",
    EE: "에스토니아",
    ET: "에티오피아",
    FJ: "피지",
    FI: "핀란드",
    FR: "프랑스",
    GA: "가봉",
    GM: "감비아",
    GE: "조지아",
    DE: "독일",
    GH: "가나",
    GR: "그리스",
    GD: "그레나다",
    GT: "과테말라",
    GN: "기니",
    GW: "기니비사우",
    GY: "가이아나",
    HT: "아이티",
    HN: "온두라스",
    HU: "헝가리",
    IS: "아이슬란드",
    IN: "인도",
    ID: "인도네시아",
    IR: "이란",
    IQ: "이라크",
    IE: "아일랜드",
    IL: "이스라엘",
    IT: "이탈리아",
    JM: "자메이카",
    JP: "일본",
    JO: "조던",
    KZ: "카자흐스탄",
    KE: "케냐",
    KI: "키리바시",
    KP: "북한",
    KR: "한국",
    KW: "쿠웨이트",
    KG: "키르기스스탄",
    LA: "라오스",
    LV: "라트비아",
    LB: "레바논",
    LS: "레소토",
    LR: "라이베리아",
    LY: "리비아",
    LI: "리히텐슈타인",
    LT: "리투아니아",
    LU: "룩셈부르크",
    MG: "마다가스카르",
    MW: "말라위",
    MY: "말레이시아",
    MV: "몰디브",
    ML: "말리",
    MT: "몰타",
    MH: "마셜 제도",
    MR: "모리타니",
    MU: "모리셔스",
    MX: "멕시코",
    MD: "몰도바",
    MC : "모나코",
    MN: "몽골",
    ME: "블랙 마운틴",
    MA: "모로코",
    MZ: "모잠비크",
    MM: "미얀마",
    NA: "나미비아",
    NR: "나우루",
    NP: "네팔",
    NL: "네덜란드",
    NZ: "뉴질랜드",
    NI: "니카라과",
    NE: "니제르",
    NG: "나이지리아",
    NO: "노르웨이",
    OM: "오만",
    PK: "파키스탄",
    PW: "팔라우",
    PA: "파나마",
    PG: "파푸아뉴기니",
    PY: "파라과이",
    PE: "페루",
    PH: "필리핀",
    PL: "폴란드",
    PT: "포르투갈",
    QA: "카타르",
    RO: "루마니아",
    RU: "러시아",
    RW: "르완다",
    KN: "세인트키츠네비스",
    LC: "세인트 루시아",
    VC: "세인트 빈센트 그레나딘",
    WS: "사모아",
    SM: "산마리노",
    ST: "상투메 프린시페",
    SA: "사우디 아라비아",
    SN: "세네갈",
    RS: "세르비아",
    SC: "세이셸",
    SL: "시에라리온",
    SG: "싱가포르",
    SK: "슬로바키아",
    SI: "슬로베니아",
    SB: "솔로몬 제도",
    SO: "소말리아",
    ZA: "남아프리카",
    ES: "스페인",
    LK: "스리랑카",
    SD: "수단",
    SR: "수리남",
    SZ: "스와질랜드",
    SE: "스웨덴",
    CH: "스위스",
    SY: "시리아",
    TW: "대만",
    TJ: "타지키스탄",
    TZ: "탄자니아",
    TH: "태국",
    TL: "동티모르",
    TG: "토고",
    TO: "통가",
    TT: "트리니다드 토바고",
    TN: "튀니지",
    TR: "터키어",
    TM: "투르크메니스탄",
    TV: "투발루",
    UG: "우간다",
    UA: "우크라이나",
    AE: "아랍에미리트",
    GB: "대영제국",
    US: "미국",
    UY: "우루과이",
    UZ: "우즈베키스탄",
    VU: "바누아투",
    VE: "베네수엘라",
    VN: "베트남",
    YE: "예멘",
    ZM: "잠비아",
    ZW: "짐바브웨",
    FM: "피지"
};

export default country;